export enum ClientTypes {
    WebApi = 0,
    GraphApi = 1,
    SnakeApi = 2,
}
